import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

const links = [
  ["Hikâyemiz", "#hikayemiz"],
  ["Albüm", "#album"],
  ["Galeri", "/galeri"],
  ["Paketler", "#paketler"],
  ["İletişim", "#iletisim"],
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const closeMenu = () => setOpen(false);

  return (
    <header className="site-header" data-testid="site-header">
      <a className="brand-mark" href="#anasayfa" data-testid="header-brand-link">
        <span>Eylül</span> Fotoğrafçılık
      </a>
      <nav className={open ? "nav-links nav-open" : "nav-links"} data-testid="site-navigation">
        {links.map(([label, href]) => href.startsWith("/") ? (
          <Link to={href} key={href} onClick={closeMenu} data-testid={`navigation-${label.toLocaleLowerCase("tr-TR")}-link`}>{label}</Link>
        ) : (
          <a href={href} key={href} onClick={closeMenu} data-testid={`navigation-${label.toLocaleLowerCase("tr-TR")}-link`}>{label}</a>
        ))}
        <Link to="/admin" onClick={closeMenu} data-testid="admin-panel-link">Yönetim</Link>
      </nav>
      <button aria-label="Menüyü aç" className="menu-button" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle-button">
        {open ? <X size={19} /> : <Menu size={19} />}
      </button>
    </header>
  );
}